import { Permissions } from '../../../../models/enums/permissions';
import { Drawer } from '@material-ui/core';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { Button } from '../../../../components/button/Button';
import { DataGroup } from '../../../../components/data-group/DataGroup';
import { DataGroupPoint } from '../../../../components/data-group/DataGroupPoint';
import { FlyoutFooter } from '../../../../components/flyout-components/FlyoutFooter';
import { CurrencyInput } from '../../../../components/form-elements/CurrencyInput';
import { TextInput } from '../../../../components/form-elements/TextInput';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { SearchOrderSummary } from '../../../../models/ordering/search-order-summary';
import { OrderingSvc } from '../../../../modules/ordering/service';
import { StatusCode } from '../../../../utils/api';
import { AppUtils } from '../../../../utils/app-utils';
import { ModelValidator } from '../../../../utils/model-validator';
import { DocumentPickListReportExport } from './PickListReport';
import { ShipOrderCommand } from './ship-order-command';
import { OrderShipmentStatus } from '../../../../models/ordering/enums/order-shipment-status';

interface IProps {
    isOpen: boolean;
    onClose: any;
    orderObj: SearchOrderSummary;
}

export const FedexFlyout = (props: IProps) => {

    let freight: any = 0;
    const dispatch = useDispatch();
    const [orderService] = React.useState(new OrderingSvc());
    const [errorMsgs, setErrorMsgs] = React.useState({} as any);
    const [orderCopy, setOrderCopy] = React.useState(null as unknown as SearchOrderSummary)

    React.useEffect(() => {
        if (props.isOpen) {
            freight = props.orderObj.freight;
            setOrderCopy({ ...props.orderObj });
        }
    }, [props.isOpen]);

    const closeFlyout = () => {
        props.onClose();
    };

    const exportPicklist = () => {
        const req = new DocumentPickListReportExport(orderCopy.id);
        dispatch(getDocumentHelper(req));
    };

    const shipOrder = async () => {
        var command = new ShipOrderCommand();
        command.orderId = orderCopy.id;
        command.trackingNumber = orderCopy.trackingNumber;
        command.freight = orderCopy.freight;

        const passed = _validateData(command);
        if (passed) {
            const result = await orderService.shipOrder(command);
            if (result.status === StatusCode.Success) {
                const tmpModel = { ...orderCopy };
                tmpModel.shipmentStatus = OrderShipmentStatus.Completed;
                setOrderCopy(tmpModel);
            }
            props.onClose();
        }
    };

    const canShip = () => {
        return orderCopy.shipmentStatus == OrderShipmentStatus.Open;
    };

    const onTrackingNumberChange = (e: any) => {

        if (e && e.target && e.target.value !== undefined) {
            const tmpModel = { ...orderCopy };
            tmpModel.trackingNumber = e.target.value;
            setOrderCopy(tmpModel);
        } 
    };

    const onFreightChange = (e: React.FormEvent<HTMLInputElement>, newValue: number) => {
        if (newValue !== undefined) {
            const tmpModel = { ...orderCopy };
            tmpModel.freight = newValue;
            setOrderCopy(tmpModel);
        } 
    };

    const _validateData = (orderVM: ShipOrderCommand) => {
        const msgs = ModelValidator.validate(orderVM);
        if (AppUtils.IsEmpty(msgs)) {
            setErrorMsgs({});
            return true;
        }

        setErrorMsgs(msgs);
        return false;
    }

    return (
        orderCopy
            ? <Drawer
                anchor="right"
                onClose={closeFlyout}
                open={props.isOpen}>
                <div className="stop-action-drawer half fedex-status-flyout">
                    <div className="row">
                        <div className="col">
                            <h1>Order Details</h1>
                        </div>
                    </div>

                    <div className="row order-body">
                        <div className="col">
                            <DataGroup title="">
                                <DataGroupPoint
                                    label="Order ID"
                                    value={orderCopy.id}
                                    contentValue={
                                        <React.Fragment> 
                                            {
                                                `${orderCopy.id} `
                                            }
                                            {
                                                <a id="picklist-fedex-flyout"
                                                    onClick={exportPicklist}>PICK LIST</a>
                                            }
                                        </React.Fragment>
                                    }
                                />
                                <DataGroupPoint
                                    label="Description"
                                    value={orderCopy.description} />
                                <DataGroupPoint
                                    label="Service Center"
                                    value={orderCopy.serviceCenterId} />
                            </DataGroup>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col">
                            <CurrencyInput
                                id="freight-fedex-flyout"
                                label="Freight"
                                currencyType={orderCopy.currencyId}
                                showSymbol={true}
                                value={orderCopy.freight}
                                disable={!canShip()}
                                ref={(instance) => { freight = instance; }}
                                onChange={onFreightChange}                                
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <TextInput
                                id="tracking-number-fedex-flyout"
                                type="text"
                                label="Tracking Number"
                                name="trackingNumber"
                                error={errorMsgs.trackingNumber}
                                value={orderCopy.trackingNumber}
                                disable={!canShip()}
                                onChange={onTrackingNumberChange}
                            />
                        </div>
                    </div>

                    <FlyoutFooter>
                        <div className="row">
                            <div className="col">
                                {
                                    canShip() ? <HasPermission requiredPermissions={[
                                    Permissions.ShippingFedexShip]}>
                                    <Button
                                        text="Ship"
                                        classes="action attention"
                                        testID="ship-fedex-flyout"
                                        disable={!canShip()}
                                        onBtnClick={shipOrder} />
                                    </HasPermission> : null
                                }
                                <Button
                                    text="Cancel"
                                    classes="action negative"
                                    testID="close-fedex-flyout"
                                    onBtnClick={closeFlyout} />
                            </div>
                        </div>
                    </FlyoutFooter>

                </div>
            </Drawer>
            : null
    );
};
